import React from 'react';
import { LayoutGrid, Calendar, PlusCircle, BarChart2, StickyNote } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export default function BottomNav() {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (route) => {
    if (route === '/') return path === '/';
    return path.startsWith(route);
  };

  const items = [
    { to: '/', icon: LayoutGrid, label: 'Home', check: '/' },
    { to: '/months', icon: Calendar, label: 'Months', check: '/month' },
    { to: '/new', icon: PlusCircle, label: 'New', check: '/new', featured: true },
    { to: '/sticky-board', icon: StickyNote, label: 'Sticky', check: '/sticky-board' },
    { to: '/reports', icon: BarChart2, label: 'Reports', check: '/reports' },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40">
      {/* Frosted glass bar */}
      <div
        className="flex justify-around items-end h-[72px] px-2 pb-2 rounded-t-3xl border-t border-gray-100"
        style={{
          background: 'rgba(255,255,255,0.92)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          boxShadow: '0 -4px 24px rgba(0,0,0,0.08)',
        }}
      >
        {items.map(({ to, icon: Icon, label, check, featured }) => {
          const active = isActive(check);
          if (featured) {
            return (
              <Link
                key={to}
                to={to}
                className="flex flex-col items-center justify-center -mt-6 w-14"
              >
                {/* Floating action button style for "New" */}
                <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-90 ${
                  active
                    ? 'bg-blue-700'
                    : 'bg-gradient-to-br from-blue-500 to-blue-700'
                }`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <span className="text-[10px] font-semibold text-blue-600 mt-1">{label}</span>
              </Link>
            );
          }
          return (
            <Link
              key={to}
              to={to}
              className="flex flex-col items-center justify-end w-full h-full pb-1 gap-0.5"
            >
              <div className={`p-1.5 rounded-2xl transition-all ${active ? 'bg-blue-50' : ''}`}>
                <Icon className={`w-5 h-5 transition-colors ${active ? 'text-blue-600' : 'text-slate-400'}`} />
              </div>
              <span className={`text-[10px] font-semibold transition-colors ${active ? 'text-blue-600' : 'text-slate-400'}`}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
